// extracted by mini-css-extract-plugin
export default {"buttonTopMargin":"PersonalData_buttonTopMargin__UUEXL","downloadButton":"PersonalData_downloadButton__V3uym","personalDataPage":"PersonalData_personalDataPage__JG1N0"};